export function protoExtend<T extends object, U extends object>(
  obj: T,
  extension: U
): T & U {
  function O(this: T & U, extension: U) {
    Object.assign(this, extension);
  }

  O.prototype = obj;
  // @ts-ignore : constructeur non standard, c'est voulu
  return new (O as any)(extension) as T & U;
}

/**
 * Like protoExtend, but obj keeps the precedence: only the properties of defaults
 * that obj does not already have (own or inherited) are added.
 */
export function protoExtendDefaults<T extends object, U extends object>(
  obj: T,
  defaults: U
): T & U {
  const missing: Partial<U> = {};
  for (const key in defaults) {
    if (!(key in Object(obj))) {
      missing[key] = defaults[key];
    }
  }
  return protoExtend(obj, missing) as T & U;
}
